/* Crocpad Contact Form (Support → Enquiries, Phase 1).
   Loaded from layout/theme.liquid via a gated <script> (Shopify strips inline
   <script> from section render context). Boots only when .crocpad-contact-form
   is on the page, so it's safe to load site-wide. Posts multipart FormData to
   the hub — do NOT set Content-Type (the browser sets the multipart boundary). */
(function () {
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function boot() {
    var root = document.querySelector('.crocpad-contact-form');
    if (!root) return;
    var form = root.querySelector('#ccf-form');
    if (!form || form.__ccfBound) return;
    form.__ccfBound = true;

    var API = 'https://hub.crocpad.com/api/support/enquiries';
    var alertEl = root.querySelector('#ccf-alert');

    function showAlert(msg, ok) {
      alertEl.textContent = msg;
      alertEl.style.display = 'block';
      alertEl.className = 'ccf-alert ' + (ok ? 'ccf-ok' : 'ccf-err');
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var first = (root.querySelector('#ccf-first').value || '').trim();
      var last  = (root.querySelector('#ccf-last').value || '').trim();
      var name  = (first + ' ' + last).trim();
      var email = (root.querySelector('#ccf-email').value || '').trim();
      var subject = (root.querySelector('#ccf-subject').value || '').trim();
      var message = (root.querySelector('#ccf-message').value || '').trim();
      var phone = (root.querySelector('#ccf-phone').value || '').trim();

      if (!first || !last || !email || !subject || !message) {
        showAlert('Please fill in your first name, last name, email, subject and message.', false);
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showAlert('Please enter a valid email address.', false);
        return;
      }

      var fd = new FormData();
      fd.append('first_name', first);
      fd.append('last_name', last);
      // sent as well so anything still reading a single field keeps working; the
      // API prefers first_name/last_name when both are present.
      fd.append('name', name);
      fd.append('email', email);
      fd.append('subject', subject);
      fd.append('message', message);
      fd.append('phone', phone);
      var fi = root.querySelector('#ccf-files');
      if (fi && fi.files) { for (var i = 0; i < fi.files.length; i++) { fd.append('files', fi.files[i], fi.files[i].name); } }

      var btn = root.querySelector('#ccf-submit');
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Sending…';
      alertEl.style.display = 'none';

      fetch(API, { method: 'POST', mode: 'cors', body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || res.body.success !== true) {
            throw new Error((res.body && (res.body.error || res.body.message)) || 'Submission failed');
          }
          form.style.display = 'none';
          var sc = root.querySelector('#ccf-success');
          sc.style.display = 'block';
          sc.innerHTML =
            '<div class="ccf-success-box"><div class="ccf-check">✓</div>' +
            '<h3>Thanks, ' + esc(name.split(' ')[0]) + '!</h3>' +
            '<p>We’ve received your enquiry (<strong>' + esc(res.body.enquiry_ref || '') + '</strong>). ' +
            'We’ll reply to <strong>' + esc(email) + '</strong> as soon as we can.</p></div>';
        })
        .catch(function (err) {
          showAlert((err && err.message) || 'Something went wrong. Please email support@crocpad.com.au.', false);
          btn.disabled = false; btn.textContent = orig;
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
